import React from 'react';

// The interpretation texts (utils/aspectInterpretations) mark their headings **like this**: show them in bold, not as asterisks.
export const withBoldMarks = (text: string): React.ReactNode[] =>
  text.split(/\*\*(.+?)\*\*/g).map((part, i) => (i % 2 ? <strong key={i}>{part}</strong> : part));
